import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import InfoDetailsDeadlines from "./infoDetails";
import PreviewDeadlines from "./preview";
import Preview from "../../documentDetails/preview/index";
import SwitcherDetailDeadlines from "./switcher";
import MessageNote from "../../messageNote/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  setDeadlineDetailAuthorize,
  setDeadlineDetailPayment,
  setDeadlineDetailReject
} from "../../../store/actions/deadlines/detail";
import { loadPreview } from "../../../store/actions/deadlines/preview";
import { downloadDocument } from "../../../store/actions/download";
import { getEffectiveOrNot } from "../../../store/actions/deadlines/accountant";

const DeadlinesDetails = props => {
  const {    
    getDetailDetailsById,
    isFullscreenOverlay
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const deadlinesDetail = useSelector(state => state.deadlinesDetail);
  const deadlines = useSelector(state => state.deadlinesAccountant);
  const deadlinesCompany = useSelector(state => state.deadlinesCompany);
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const companySelected = main.companySelected;
  const  clientIdSelected = main.clientIdSelected;
  const myType = main.myType;
  const prevPath = main.prevPath;

  const dispatch = useDispatch();  

  const [documentIdInPreview, setDocumentIdInPreview] = useState(null);
  const [currentTab, setCurrentTab] = useState(1);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [currentDetailId, setCurrentDetailId] = useState(location.pathname.split("scadenza/")
    ? location.pathname.split("scadenza/")[1]
    : null);
  const downloadLoading = false;

  const isEinvoice = deadline => {

    if (deadline.attachmentsDetail && deadline.attachmentsDetail.length > 0){
      return deadline.attachmentsDetail[0].einvoice;
    } 
    return deadline.counterpart &&
      deadline.counterpart.taxId &&
      ["debt", "credit"].indexOf(deadline.scope) > -1;
    
  };

  const setAuthorize = () => {
    dispatch(setDeadlineDetailAuthorize());
  };

  const setUnauthorize = () => {
    dispatch(setDeadlineDetailReject());
  };

  const setPayment = (
    paymentStatus, paymentMode, paymentDate
  ) => {
    dispatch(setDeadlineDetailPayment(
      currentDetailId,
      paymentStatus,
      paymentMode,
      paymentDate
    ));
  };

  const documentIdInPreviewHandler = currentDocId => {
    setDocumentIdInPreview(currentDocId);
  };

  const previewDeadlinesHandler = index => {
    setPreviewIndex(index);
  };

  const changePreview = (idDocument, page) => {
    dispatch(loadPreview(
      clientIdSelected,
      idDocument,
      page
    ));
  };

  const getDownloadDoc = (index = 1) => {
    dispatch(downloadDocument(
      deadlinesDetail.subjective.attachmentsDetail[index].documentId,
      deadlinesDetail.subjective.attachmentsDetail[index].fileName,
      false,
      ".pdf"
    ));
  };

  const setCurrentDeadlinesId = currentId => {
    setDocumentIdInPreview(null);
    setCurrentDetailId(currentId);
    navigate({
      pathname: `/scadenza/${currentId}${location.search}`,
      search: location.search,
      state: location.state
    });

    getDetailDetailsById(currentId);
  };

  const getNextDeadlines = () => {
    if (deadlines.effectiveOrNot.status) {
      if (
        typeof nextHref !== "undefined" &&
        deadlines.effectiveOrNot.status.ended &&
        myType === "STUDIO"
      ) {
        dispatch(getEffectiveOrNot(
          false,
          deadlines.effectiveOrNot.nextHref.href,
          false,
          deadlines.filtersActive,
          true
        ));
      }
    }
  };

  const subjective =
    myType === "STUDIO" && prevPath !== "/scheda-cliente"
      ? deadlines.effectiveOrNot.deadlines
      : deadlinesCompany.subjective;
  const isLoadingSubjective = deadlinesCompany.isGettingDeadlines;

  // le info sono bordate se non c'è un'allegato altrimenti no da mockup
  const deadline = deadlinesDetail.subjective;
  const hasAttachments =
    deadline && deadline.attachments && deadline.attachments.length > 0;
  const attachmentsDetails = deadline ? deadline.attachmentsDetail : [];
  const currentAttachmentId =
    deadline &&
    deadline.attachmentsDetail &&
    deadline.attachmentsDetail.length > 0
      ? documentIdInPreview
        ? documentIdInPreview
        : deadline.attachmentsDetail[0].documentId
      : undefined;

  let currentAttachmentDetails;
  if (attachmentsDetails !== undefined) {
    currentAttachmentDetails = attachmentsDetails
      ? attachmentsDetails.find(doc => doc.documentId === currentAttachmentId)
      : undefined;
  }

  let classNameInfoContainer = hasAttachments ? "infoNoBorder" : "infoBorder";

  let notesCount =
    currentAttachmentDetails && currentAttachmentDetails.notes
      ? currentAttachmentDetails.notes.length
      : 0;

  let documentId;

  const documentIdCalculator = () => {
    if (documentIdInPreview === null) {
      if (currentAttachmentDetails !== undefined) {
        documentId = currentAttachmentDetails.documentId;
        return documentId;
      }
    } else {
      documentId = documentIdInPreview;
      return documentId;
    }
    return undefined;
  };

  const isEinvoiceVar = isEinvoice(deadline);

  return (
    <div className="containerDetail">
      {auth && accountantSelected && companySelected ? (
        <div className="contentDetail deadline">
          <div id="column2" style={{ width: "50%" }}>
            <div className="tabContainer">
              <div
                className={
                  "itemContainer " + (currentTab === 1 ? "active" : "")
                }
                id="dettaglio_scadenza"
                onClick={() => setCurrentTab(1)}
              >
                <div>
                  <FormattedMessage id="deadlines.pages.detail.tab1" />
                </div>
              </div>
              <div
                className={
                  "itemContainer gs-documents-detail-tab-note " +
                  (currentTab === 2 ? "active" : "")
                }
                id="note_scadenza"
                onClick={() => setCurrentTab(2)}
              >
                <div>
                  <span style={{ verticalAlign: "middle" }}>
                    <FormattedMessage id="deadlines.pages.detail.tab2" />{" "}
                  </span>{" "}
                  {notesCount > 0 ? (
                    <div className="badgeNote">
                      {notesCount > 100 ? "99+" : notesCount}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            {(deadlinesDetail.subjective ||
              deadlinesDetail.isGettingDeadlines) &&
            currentTab === 1 ? (
                <InfoDetailsDeadlines
                  classNameInfoContainer={classNameInfoContainer}                  
                  infoObj={deadlinesDetail.subjective}
                  isEinvoice={isEinvoiceVar}
                  isLoading={deadlinesDetail.isGettingDeadlines}
                  isFullscreenOverlay={isFullscreenOverlay}
                  setAuthorize={setAuthorize}
                  setPayment={setPayment}
                  setUnauthorize={setUnauthorize}
                  totalDayImport={deadlinesDetail.dailyTotals}
                  documentIdInPreviewHandler={documentIdInPreviewHandler}
                  documentIdInPreview={documentIdInPreview || currentAttachmentId}
                  previewDeadlinesHandler={previewDeadlinesHandler}
                  getDetailDetailsById={getDetailDetailsById}
                />
              ) : null}

            {currentAttachmentDetails &&
            !deadlinesDetail.isLoadingPreview &&
            currentTab === 2 ? (
                <div style={{ marginLeft: 50, marginTop: 50 }}>
                  <MessageNote
                    docID={currentAttachmentDetails.documentId}
                    notes={currentAttachmentDetails.notes}
                    typeAccount={myType}
                    scope="deadlines"
                    isFullscreenOverlay={isFullscreenOverlay}
                  />
                </div>
              ) : null}
          </div>

          <div id="column1" style={{ width: "50%" }}>
            {hasAttachments && !isEinvoiceVar && (
              <PreviewDeadlines
                changePreview={changePreview}
                downloadDocument={index => getDownloadDoc(index)}
                isLoadingPreview={deadlinesDetail.isLoadingPreview}
                downloadLoading={downloadLoading}
                previewDeadlinesHandler={previewDeadlinesHandler}
                previewIndex={previewIndex}
              />
            )}
            {hasAttachments &&
              isEinvoiceVar &&
              currentAttachmentDetails &&
              currentAttachmentDetails.documentId && (
              <Preview
                accountantSelected={accountantSelected}
                accountantIdSelected={accountantIdSelected}
                companySelected={companySelected}
                clientIdSelected={clientIdSelected}
                myType={myType}
                isEinvoice={isEinvoiceVar}
                documentId={documentIdCalculator()}
                fileName={currentAttachmentDetails.fileName}
                previewDeadlinesHandler={previewDeadlinesHandler}
                previewIndex={previewIndex}
              />
            )}
          </div>
        </div>
      ) : (
        <div style={{ flex: "0 0 auto", margin: "auto" }}>
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            style={{ fontSize: "50px", color: "#2184C2" }}
            spin
          />{" "}
        </div>
      )}
      <div className="footerStickyDetail">
        {!deadlinesDetail.isGettingDeadlines &&
        subjective &&
        subjective.length > 1 &&
        !main.widgets.fullscreenOverlay.visible ? (
            <SwitcherDetailDeadlines
              currentDetailId={currentDetailId}
              deadlinesList={subjective}
              deadlineListFilter={subjective?.filter(el => {
                return el.status.confirmed === true;
              })}
              isLoadingSubjective={isLoadingSubjective}
              getNextDeadlines={getNextDeadlines}
              setCurrentDeadlinesId={setCurrentDeadlinesId}
            />
          ) : null}
      </div>
    </div>
  );
};

export default DeadlinesDetails;
